import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Moment from "react-moment";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, GenericButton } from "shared/ui-basics";
import styled, { css } from "styled-components/macro";
import { useModal } from "use-modal-hook";
import { SupportForm } from "../SupportForm";
import { DropdownWrapper } from "./nav-menu-header-style";

export default function NeedHelpOptions({ hideForPdf }) {
	const { t } = useTranslation();
	const history = useHistory();
	const [showSupportModal] = useModal(SupportForm);

	return <Button variant="clean" size="l"  className="px-1" onClick={showSupportModal}>
		<NeedHelp>
			{hideForPdf ? (
				<>
					{t("EXPORT_DATE")}
					<Moment format="DD/MM/YYYY">{new Date()}</Moment>
				</>
			) : (
				t("NEED_HELP") + "?"
			)}
		</NeedHelp>
	</Button>

}

const NeedHelp = styled.div`
	color: #605f60;
	font-family: "Inter";
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	:hover {
		cursor: pointer;
		text-decoration: underline;
		opacity: 1;
	}
`;

